





// import Cookies from "js-cookie";

// const TOKEN_KEY = "adminToken";

// export const setToken = (token) => {
//   Cookies.set(TOKEN_KEY, token, {
//     expires: 7,
//     sameSite: "Strict",
//     // secure: process.env.NODE_ENV === "production",
//      secure: false,
//   });
// };

// export const getToken = () => {
//   return Cookies.get(TOKEN_KEY);
// };

// export const removeToken = () => {
//   Cookies.remove(TOKEN_KEY);
// };

import Cookies from "js-cookie";

const TOKEN_KEY = "adminToken";

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token, {
    expires: 7,
    sameSite: "Strict",
    // secure: process.env.NODE_ENV === "production",
     secure: false,
  });
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};